import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import {clearNotifications} from '../../actions';
import classnames from 'classnames';

import './Notifications.less';

export class Notifications extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            type: this.props.type,
            message: this.props.message,
            fallbackMessage: this.props.fallbackMsg,
            visibility: this.props.visible ? 'visible' : ''
        };
    }

    componentWillReceiveProps(props) {
        if (props.msg) {
            this.props.clear();
            this.setState({
                type: props.type,
                message: props.msg,
                fallbackMessage: props.fallbackMsg,
                visibility: 'visible'
            });
            setTimeout(() => {
                this.setState({
                    type: '',
                    message: '',
                    fallbackMessage: '',
                    visibility: ''
                });
            }, 5000);
        }
    }
    render() {
        const { t } = this.props;
        var notifyClass = classnames(['alert-message', this.state.type, this.state.visibility]);
        if (this.state.visibility) {
            return (
                <div className="privacy-settings alert-wrapper relative">
                    <div className={notifyClass}>
                        <p>{t([this.state.message, this.state.fallbackMessage])}</p>
                    </div>
                </div>
            )
        }
        return null;
    }
}

Notifications.propTypes = {
    clear: PropTypes.func
};

const mapStateToProps = (state) => state.notification ? state.notification : {};

const mapDispatchToProps = dispatch => {
    return {
        clear: () => dispatch(clearNotifications())
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps), translate(['common'], { wait: true }))(Notifications);



// WEBPACK FOOTER //
// ./src/UserSettings/components/Notifications/index.jsx